import { useNavigate } from 'react-router-dom';

export const useBackNavigation = () => {
  const navigate = useNavigate();

  return (fallbackPath:string) => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate(fallbackPath);
    }
  };
};
